import axios from 'axios';
import { ErrorResponse } from '@/shared/types';

const SWITCH_TOKEN_INVALID_CODES = [1002, 1003, 1004, 1005];
const SWITCH_TOKEN_INVALID_STATUSES = [401, 403];

export class SwitchSessionTerminatedError extends Error {
  constructor(cause?: unknown) {
    super('The account switch session has ended.', { cause });
    this.name = 'SwitchSessionTerminatedError';
  }
}

export class SwitchTokenRefreshRaceError extends Error {
  constructor() {
    super('The account switch refresh token changed while refreshing.');
    this.name = 'SwitchTokenRefreshRaceError';
  }
}

export const isDefinitiveSwitchTokenRefreshFailure = (
  error: unknown,
): boolean => {
  if (error instanceof SwitchSessionTerminatedError) return true;
  if (!axios.isAxiosError<ErrorResponse>(error)) return false;

  const status = error.response?.status;
  if (status && SWITCH_TOKEN_INVALID_STATUSES.includes(status)) return true;

  const errorCode = Number(error.response?.data?.code);
  return (
    Number.isFinite(errorCode) && SWITCH_TOKEN_INVALID_CODES.includes(errorCode)
  );
};
